/**
 * UXB — tryb jasny/ciemny. Token override w tokens.css pod [data-theme="light"].
 * PIERWSZY SHIP: domyślnie ciemny (obecne zachowanie); light = OPT-IN przez przełącznik
 * (localStorage). prefers-color-scheme NIE jest auto-stosowany dopóki nie ma QA wizualnego
 * wszystkich ekranów w jasnym — do włączenia później (zmień getTheme).
 */
const META_DARK = '#0f1410';
const META_LIGHT = '#f2f0e9';

export function getTheme() {
  try {
    const saved = localStorage.getItem('theme');
    if (saved === 'light' || saved === 'dark') return saved;
  } catch { /* prywatny tryb */ }
  return 'dark';
}

export function applyTheme(theme) {
  const t = theme === 'light' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', t);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', t === 'light' ? META_LIGHT : META_DARK);
}

export function setTheme(theme) {
  try { localStorage.setItem('theme', theme); } catch { /* prywatny tryb */ }
  applyTheme(theme);
}

export function initTheme() {
  applyTheme(getTheme());
}

export function toggleTheme() {
  const next = getTheme() === 'light' ? 'dark' : 'light';
  setTheme(next);
  return next;
}
